import React, { createContext, useContext, useMemo, useState } from 'react';

import { Context } from './types/context';
import { RoutesError } from './types/routesError';

import useRoutesPoints from './hooks/useRoutesPoints';
import useRoutes from './hooks/useRoutes';
import useActiveRoutes from './hooks/useActiveRoutes';
import useRoutesStations from './hooks/useRoutesStations';
import { useNavigationHistoryRoutes } from './hooks';

interface Props {
  children: React.ReactNode;
}

export const RoutesContext = createContext({} as Context);
export const useRoutesContext = () => useContext(RoutesContext);
export * from './hooks';

const RoutesProvider = ({ children }: Props) => {
  const [ routesError, setRoutesError ] = useState<RoutesError>();
  const { routes, setRoutes, onChangeRoutes, getRouteById, resetRoutes } = useRoutes(setRoutesError);
  const { activeRoute, setActiveRoute, resetActiveRoute } = useActiveRoutes();
  const { routesPoints, setRoutesPoints, resetRoutesPoints } = useRoutesPoints();
  const { routesStations, setRoutesStations, getRouteStationsById } = useRoutesStations();
  const { navigationHistoryRoutes, setNavigationHistoryRoutes } = useNavigationHistoryRoutes();
  const [ routeRoadsideServicesStations, setRouteRoadsideServicesStations ] = useState<Context['routeRoadsideServicesStations']>({});
  const [ routeServicesStations, setRouteServicesStations ] = useState<Context['routeServicesStations']>({});

  const value = useMemo(() => ({
    routesError,
    setRoutesError,

    routes,
    setRoutes,
    onChangeRoutes,
    getRouteById,
    resetRoutes,

    activeRoute,
    setActiveRoute,
    resetActiveRoute,

    routesPoints,
    setRoutesPoints,
    resetRoutesPoints,

    routesStations,
    setRoutesStations,
    getRouteStationsById,

    navigationHistoryRoutes,
    setNavigationHistoryRoutes,

    routeRoadsideServicesStations,
    setRouteRoadsideServicesStations,

    routeServicesStations,
    setRouteServicesStations
  }), [
    routesError,
    setRoutesError,

    routes,
    setRoutes,
    onChangeRoutes,
    getRouteById,
    resetRoutes,

    activeRoute,
    setActiveRoute,
    resetActiveRoute,

    routesPoints,
    setRoutesPoints,
    resetRoutesPoints,

    routesStations,
    setRoutesStations,
    getRouteStationsById,

    navigationHistoryRoutes,
    setNavigationHistoryRoutes,

    routeRoadsideServicesStations,
    setRouteRoadsideServicesStations,

    routeServicesStations,
    setRouteServicesStations
  ]);

  return (
    <RoutesContext.Provider value={value}>{children}</RoutesContext.Provider>
  );
};

export default RoutesProvider;
